import React, { useEffect } from 'react'
import IndyCarTable from '../../Components/IndyCarTable/page'
import Banner2 from '../../Components/Banner/Banner2'

const Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Banner2 title="WELCOME TO INDYCAR SERIES" backgroundImage="/assets/images/banner/video-banner-1.jpg"/>
    {/* <DriverSec3/> */}
    <IndyCarTable/>
    </>
  )
}

export default Page